import { Row } from "@narmi/design_system";
import styles from "./StatusInfoRow.module.css";

interface StatusInfoRowProps {
  label: string;
  value?: string | null;
  status: "success" | "error";
}

function StatusInfoRow(props: StatusInfoRowProps) {
  return (
    <Row className={styles.infoRow}>
      <div className={styles.infoCell}>
        {props.status === "success" && (
          <span className={`narmi-icon-check-circle ${styles.statusSuccess}`} />
        )}
        {props.status === "error" && (
          <span className={`narmi-icon-alert-circle ${styles.statusError}`} />
        )}
        {props.label}
      </div>
      <div className={`${styles.infoCell} sentry-mask`}>{props?.value ?? ""}</div>
    </Row>
  );
}

export { StatusInfoRow };
